import { createContext, use } from 'react';

// ============================================================================
// Sticky Header Context
// ============================================================================

export type StickyHeaderContextValue = {
    stickyOffset: number;
    registerHeader: (node: HTMLDivElement | null) => void;
};

export const StickyHeaderContext = createContext<StickyHeaderContextValue | null>(null);

export function useStickyHeaderContext() {
    return use(StickyHeaderContext);
}


